<tr>
    <th>{{ 'users.supplierUsers.edit.visualPermissions.headings.main.visuals' | translate }}</th>
    <td>{{ 'users.supplierUsers.edit.visualPermissions.headings.columns.view' | translate }}</td>
    <td>{{ 'users.supplierUsers.edit.visualPermissions.headings.columns.edit' | translate }}</td>
    @if (hasActivePermissions()) {
        <td>{{ 'users.supplierUsers.edit.visualPermissions.headings.columns.active' | translate }}</td>
    }
</tr>

@for (permission of processedPermissions(); track permission.name) {
    @if (permission.isVisible) {
        <ng-container
            [ngTemplateOutlet]="visualPermissionRowTemplate"
            [ngTemplateOutletContext]="{ permission: permission, isChild: false }"
        ></ng-container>
    }
}

<tr class="spacer">
    <td colspan="6"></td>
</tr>

<ng-template #visualPermissionRowTemplate let-permission="permission" let-isChild="isChild">
    <tr [class.child-permission]="isChild" [formGroup]="permissionsForm">
        <td>
            <span [class.permission-name]="!isChild">
                {{ permission.translationKey | translate }}
            </span>
        </td>

        <!-- View column -->
        @if (permission.possibleAccessTypes.includes(accessTypeEnum.VIEW)) {
            <td>
                <input type="checkbox" [formControlName]="permission.name + '_' + accessTypeEnum.VIEW" />
            </td>
        } @else {
            <td></td>
        }

        <!-- Edit column -->
        @if (permission.possibleAccessTypes.includes(accessTypeEnum.EDIT)) {
            <td>
                <input type="checkbox" [formControlName]="permission.name + '_' + accessTypeEnum.EDIT" />
            </td>
        } @else {
            <td></td>
        }

        <!-- Active column -->
        @if (permission.possibleAccessTypes.includes(accessTypeEnum.ACTIVE)) {
            <td>
                <input type="checkbox" [formControlName]="permission.name + '_' + accessTypeEnum.ACTIVE" />
            </td>
        } @else {
            <td></td>
        }

        <!-- Empty columns to match the 6-column structure -->
        <td></td>
        <td></td>
    </tr>

    @if (permission.children && permission.children.length > 0) {
        @for (childPermission of permission.children; track childPermission.name) {
            @if (childPermission.isVisible) {
                <ng-container
                    [ngTemplateOutlet]="visualPermissionRowTemplate"
                    [ngTemplateOutletContext]="{ permission: childPermission, isChild: true }"
                ></ng-container>
            }
        }

        @if (hasActivePermissions()) {
            <!-- Add spacer after children -->
            <tr class="spacer quarter">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        }
    }
</ng-template>
